import AdbIcon from '@mui/icons-material/Adb';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { useCallback, useMemo } from 'react';

import { AppServiceFactory } from '@/modules/app/service/AppServiceFactory';

export const DebugMenu = () => {
  const appSvc = useMemo(() => AppServiceFactory.getInstance().createAppService(), []);

  const handleClick = useCallback(() => {
    appSvc.setActiveModalId('debug');
  }, [appSvc]);

  return (
    <MenuItem onClick={handleClick}>
      <ListItemIcon>
        <AdbIcon fontSize='small' />
      </ListItemIcon>
      <ListItemText>Debug Menu</ListItemText>
    </MenuItem>
  );
};
